import styled from "styled-components";
import { NoMarginParagraph } from "../input/TextField.styles";

export const YellowWarning = styled.section`
  display: flex;
  padding: var(--12px, 12px) var(--16px, 16px);
  align-items: flex-start;
  gap: var(--12px, 12px);
  align-self: stretch;
  border-radius: var(--12px, 12px);
  background: var(--Status-YELLOW-100, #FECB00);
`;

export const SmallBoldText = styled(NoMarginParagraph)`
  color: #08081B;

  font-size: ${props => props.fontSize ? props.fontSize : '14px'};
  font-style: normal;
  font-weight: bold;
  line-height: 150%;
`;
